export default "__VITE_ASSET__B6s7eJQ___"